import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { NoteSearchModel } from '../models/note-related/NoteSearchModel';
import { NoteCreateModel } from '../models/note-related/NoteCreateModel';

@Injectable()
export class NoteWidgetContainerService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/NoteWidget/`;
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public Get = (entityId: string): Observable<NoteSearchModel[]> => {
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl + entityId, options).map(res => res.json());
    }

    public Create = (newNote: NoteCreateModel): Observable<Response> => {
        this.setHeaders();
        newNote.UserId = this.uData.sub;
        let options = new RequestOptions({ headers: this.headers });
        return this._http.post(this.actionUrl, JSON.stringify(newNote), options);
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/note-widget-container/note-widget-container.service.ts